import { isRangeFilterActive } from '@features/facetingEngine/utils/facetLogic';
import { Flex, Separator } from '@radix-ui/themes';
import { FacetFlow } from './FacetFlow';
import { FacetSlider } from './FacetSlider';
import { useFacetController } from '../hooks/useFacetController';
import { RangePreset } from '..';

interface RangeFilterProps {
    facetKey: string;
}

export const RangeFilter = ({ facetKey }: RangeFilterProps) => {
    const { config, value, onChange, getLabel } =
        useFacetController<'range'>(facetKey);

    if (!config) return null;

    const { presets, unit, rangeLimits } = config;

    return (
        <Flex direction='column' gap='3'>
            <FacetSlider
                {...rangeLimits}
                unit={unit}
                value={value}
                onChange={onChange}
            />

            {presets && presets.length > 0 && (
                <>
                    <Separator
                        style={{
                            alignSelf: 'center',
                            width: '80%',
                        }}
                    />

                    <FacetFlow<RangePreset>
                        facets={presets ?? []}
                        isActive={(preset) =>
                            isRangeFilterActive(value, preset.value)
                        }
                        onSelect={(preset) => onChange(preset.value)}
                        getLabel={(preset) => getLabel(preset.key)}
                        getKey={(preset) => preset.key}
                    />
                </>
            )}
        </Flex>
    );
};
